/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import "./polyfills/at";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { EdgeToEdge } from "@capawesome/capacitor-android-edge-to-edge-support";
import * as React from "react";
import ReactDOM from "react-dom";
import { registerSW } from "virtual:pwa-register";
import { Config, initConfig } from "./config";
import { normalizeGoogleDriveOAuthCallback } from "./config/google-drive/oauth-callback";
import { registerPDFTronServiceWorker } from "./config/pdftron/service-worker/register-pdftron-sw";
import { App } from "./screens/App/App";

const isNative = Capacitor.isNativePlatform();

if (!isNative) {
  registerSW({
    immediate: true,
    onOfflineReady() {
      console.log("offline ready");
    },
  });
}

void main();

function normalizeOAuthCallbackBeforeAuth0() {
  try {
    normalizeGoogleDriveOAuthCallback({
      location: window.location,
      replaceUrl: (url) => {
        window.history.replaceState(window.history.state, "", url);
      },
      storeValue: (key, value) => {
        window.sessionStorage.setItem(key, value);
      },
    });
  } catch {
    // no-op
  }
}

async function main() {
  normalizeOAuthCallbackBeforeAuth0();
  await initConfig();

  const platform = Capacitor.getPlatform();
  const rootEl = document.documentElement;
  rootEl.setAttribute("data-platform", platform);
  if (platform === "ios") {
    rootEl.classList.add("ios");
  }

  if (platform === "android") {
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    const style = prefersDark ? Style.Light : Style.Dark;
    await StatusBar.setOverlaysWebView({ overlay: true });
    try {
      await EdgeToEdge.enable();
    } catch (e) {
      console.warn("EdgeToEdge.enable fallo o no disponible", e);
    }
    await StatusBar.setStyle({ style });
  } else if (platform === "ios") {
    await StatusBar.setStyle({ style: Style.Default });
  }

  console.info("🍀 Welcome on Clovis");

  ReactDOM.render(
    <React.StrictMode>
      <Config>
        <App />
      </Config>
    </React.StrictMode>,
    document.getElementById("root")
  );

  await registerPDFTronServiceWorker();
}
